import { Text } from '../../styles'

import { Wrapper, Title } from './styles'
import { CaseProps } from './types'

export function Case({ title, text }: CaseProps) {
  return (
    <Wrapper>
      <Title as="h4">{title}</Title>
      <Text>{text}</Text>
    </Wrapper>
  )
}
